import React from 'react';
import {Link} from 'react-router-dom';
import AurSvgIcon from '../../../common/aur-svg-icon/AurSvgIcon';

const SvgIcon: React.FC = () => {
  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>SVG Icon</h1>
        <div>
          If you need a custom SVG icon (not available in the Material Icons)
          you can use the SvgIcon wrapper. This component extends the native svg
          element.
        </div>
        <Link to="/demo">Return</Link>
        <hr />
        <div style={{marginBottom: '32px'}}>
          <div>
            <AurSvgIcon src="images/chev_right.svg" />
          </div>
          <div>
            <AurSvgIcon src="images/billing.svg" />
          </div>
        </div>
      </div>
    </>
  );
};

export default SvgIcon;
